import { Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import { memo, type ReactElement } from "react"

import { AssetStatusTypeMenuGroup, type AssetStatusTypeMenuGroupProps } from "../MenuGroups/AssetStatusTypeMenuGroup"

interface AssetStatusTypeDropdownMenuProps
	extends
		AssetStatusTypeMenuGroupProps,
		Omit<MenuRootProps, "children">,
		Omit<MenuClickTriggerProps, "children" | "ref">,
		MenuVariantProps {
	children: ReactElement
}

export const AssetStatusTypeDropdownMenu = memo((props: AssetStatusTypeDropdownMenuProps) => {
	const {
		children,
		assetStatusTypes,
		onSelectAssetStatusType,
		disabled,
		size,
		variant,
		radius,
		accentColor,
		...rest
	} = props

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content size={size} variant={variant} accentColor={accentColor} radius={radius}>
				<Menu.Scroll>
					<AssetStatusTypeMenuGroup
						assetStatusTypes={assetStatusTypes}
						onSelectAssetStatusType={onSelectAssetStatusType}
					/>
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
AssetStatusTypeDropdownMenu.displayName = "AssetStatusTypeDropdownMenu"
